import React, { useState } from "react";
import HeroArea from "./HeroArea";
import HomeProduct from "../View/Products/HomeProduct";
import Brands from "./Brands";
import News from "../View/News/News";
import Testimonial from "./Testimonial";
import FooterBanner from "./FooterBanner";
// import NotificationPrompt from "./NotificationPrompt";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
// import BusinessCategoryProduct from "../View/Products/BusinessCategoryProduct";
import BusinessCategory from "../View/Products/BusinessCategory";

export default function Homepage() {
  const [agreement, setAgreement] = useState(
    Cookies.get("bz_aggr") ? JSON.parse(Cookies.get("bz_aggr")) : false
  );

  const handleAgreement = () => {
    Cookies.set("bz_aggr", JSON.stringify(true), { expires: 30 });
    setAgreement(true);
  };

  return (
    <>
      <HeroArea />
      <BusinessCategory />
      <HomeProduct />
      {/* <BusinessCategoryProduct /> */}
      <News />
      <Brands />
      <Testimonial />
      <FooterBanner />
      {!agreement && (
        <div className="agreement">
          <div className="text">
            We use cookies for better user experience, check our T&C
            <Link to="/terms-and-conditions">here</Link>
          </div>
          <button className="agreement_btn" onClick={handleAgreement}>
            Ok, I Understand
          </button>
        </div>
      )}
    </>
  );
}
